import {Component} from '@angular/core';
import {IonApp, IonRouterOutlet} from '@ionic/angular/standalone';
import {addIcons} from 'ionicons';
import * as icons from 'ionicons/icons';
import {SwUpdate} from '@angular/service-worker';
import {LoadingService} from '../../services/ionic/loading.service';

@Component({
  selector: 'app-root',
  templateUrl: 'root.component.html',
  styleUrl: 'root.component.css',
  imports: [
    IonApp,
    IonRouterOutlet,
  ]
})
export class RootComponent {

  constructor(private swUpdate: SwUpdate,
              private loadingService: LoadingService) {
    addIcons(icons);

    this.checkForUpdates();
  }

  private async checkForUpdates() {
    console.log('Checking for updates..');

    if (!this.swUpdate.isEnabled) return;

    try {
      const start = Date.now();
      const updateAvailable = await this.swUpdate.checkForUpdate();
      const elapsed = Date.now() - start;

      if (elapsed > 5000) {
        console.warn(`Update check took ${elapsed}ms (>5s), skipping update.`);
        return;
      }

      if (updateAvailable) {
        console.log('New update available, activating and reloading page..');
        await this.swUpdate.activateUpdate();
        location.reload();
      } else {
        console.log('No new update available.');
      }
    } catch (err) {
      console.warn('Update check failed, loading offline version', err);
    }
  }

}
